import { render, staticRenderFns } from "./PushNotificationPanel.html?vue&type=template&id=d96a5a64&scoped=true&external"
import script from "./PushNotificationPanel.js?vue&type=script&lang=js&external"
export * from "./PushNotificationPanel.js?vue&type=script&lang=js&external"
import style0 from "./PushNotificationPanel.css?vue&type=style&index=0&id=d96a5a64&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96a5a64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDataTable,VIcon,VSpacer,VToolbar})
